import React from 'react';
import { motion } from 'framer-motion';
import bgMusicNotes from '../../../assets/images/occupational_theropy/therapeutic_bg.jpg';

const ModalitiesOccupationalSection = ({ services }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 360 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, ease: 'easeOut' }}
      viewport={{ once: true, amount: 0.1 }}
    >
      <div
        className="w-full rounded-[30px] md:rounded-[50px] p-10 flex flex-col gap-6 bg-cover bg-no-repeat bg-center text-white"
        style={{
          backgroundImage: `url(${bgMusicNotes})`,
        }}
      >
        <h2 className="text-[38px] sm:text-[40px] md:text-[54px] text-white border-b-2 border-white pb-2 font-bold">
          Therapeutic Listening
        </h2>

        {services.map((section, i) => (
          <div key={i}>
            <h3 className="text-[28px] md:text-[38px] 2xl:text-[48px] font-bold">
              {section.name}
            </h3>

            <p className="text-[16px] sm:text-[18px] md:text-[20px] font-medium leading-relaxed">
              {section.description}
            </p>
            {section.items && (
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 gap-x-0 sm:gap-x-10 list-disc pl-6">
                {section.items.map((item, iIndex) => (
                  <li
                    key={iIndex}
                    className="text-white text-[16px] sm:text-[18px] md:text-[20px] font-medium  leading-relaxed"
                  >
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default ModalitiesOccupationalSection;
